import { render } from "./cluster-registration-url.vue?vue&type=template&id=4b6884aa"
import script from "./cluster-registration-url.vue?vue&type=script&lang=js"
export * from "./cluster-registration-url.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__